import { render, staticRenderFns } from "./add-service.vue?vue&type=template&id=04657f5c&scoped=true&"
import script from "./add-service.vue?vue&type=script&lang=js&"
export * from "./add-service.vue?vue&type=script&lang=js&"
import style0 from "./add-service.vue?vue&type=style&index=0&id=04657f5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04657f5c",
  null
  
)

export default component.exports